import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { CONTACT } from "../mock/mock";

const CTABanner = () => {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-r from-orange-500 to-orange-400 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white/10" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-white/10" />

      <div className="relative max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Ready for your next adventure?
          </h2>
          <p className="mt-4 text-white/90 text-lg max-w-md">
            Talk to our travel expert now — free consultation, no obligations. Custom itineraries within 24 hours.
          </p>
        </div>
        <div className="flex flex-wrap gap-3 md:justify-end">
          <Button
            asChild
            size="lg"
            className="bg-white text-orange-600 hover:bg-slate-100 h-12 px-6 shadow-xl"
          >
            <a href={`tel:${CONTACT.phone}`}>
              <Phone className="w-4 h-4 mr-2" /> Call {CONTACT.phone}
            </a>
          </Button>
          <Button
            asChild
            size="lg"
            variant="outline"
            className="h-12 px-6 border-white text-white hover:bg-white hover:text-orange-600 bg-white/10 backdrop-blur"
          >
            <Link to="/contact">
              <MessageCircle className="w-4 h-4 mr-2" /> Chat with us
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
